import { render, staticRenderFns } from "./cly-avatar.vue?vue&type=template&id=11d0c875&scoped=true"
import script from "./cly-avatar.vue?vue&type=script&lang=js"
export * from "./cly-avatar.vue?vue&type=script&lang=js"
import style0 from "./cly-avatar.vue?vue&type=style&index=0&id=11d0c875&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d0c875",
  null
  
)

export default component.exports